
import { defineComponent } from 'vue';
import NImageGallery from '@/uikit/image-viewer/NImageGallery.vue';

export default defineComponent({
  name: 'ImageGallery',
  components: { NImageGallery }
});
